// extracted by mini-css-extract-plugin
export default {"newTag":"styles_newTag__dXhCr"};